import Footer from "../components/Footer/Footer";
import {
  FaWhatsapp,
  FaPhone,
  FaLocationDot,
  FaEnvelope,
  FaInstagram,
  FaDiamondTurnRight,
  FaMapLocationDot,
} from "react-icons/fa6";

function Contact() {
  const mapUrl = "https://www.google.com/maps?q=10.928267478942871,76.98478698730469&z=17&hl=en";
  const mapEmbedUrl = "https://maps.google.com/maps?q=10.928267478942871,76.98478698730469&hl=en&z=17&output=embed";

  return (
    <>
      <section className="bg-black text-white min-h-screen">
        <div className="login-banner relative justify-center flex bg-brand-gradient">
          <h1 className="text-white absolute bottom-[20px] sm:bottom-[25px] text-[26px] sm:text-[34px] md:text-[40px] font-bold">
            Contact Us
          </h1>
        </div>

        {/* Contact Info & Form */}
        <div className="py-12 sm:py-16 md:py-20 page-padding grid grid-cols-1 lg:grid-cols-2 container gap-10 sm:gap-12 items-start">
          {/* first col */}
          <div className="w-full flex flex-col">
            <h2 className="text-white text-[24px] sm:text-[30px] md:text-[36px] font-bold leading-tight mb-4">
              We Are Here To Help You Shape Your Body!
            </h2>
            <p className="text-[14px] sm:text-[16px] text-neutral-400 font-medium my-4 sm:my-6 leading-relaxed">
              At FAT2FIT Unisex Fitness Centre, our internationally certified head trainer
              G. Nandha Kumar and dedicated team are ready to guide you on your fitness journey.
              Visit us in Eachanari or reach out anytime!
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-10 mt-6">
              {/* Location */}
              <div className="flex flex-col relative">
                <h3 className="text-[18px] sm:text-[20px] font-bold mb-6 text-[#ff007f]">
                  Our Location
                </h3>
                <span className="bg-brand-gradient w-[50px] h-[3px] absolute top-[28px]"></span>
                <p className="text-[14px] font-medium text-neutral-300 leading-relaxed">
                  219 F 10/1, Ground Floor, South Facing,
                  <br /> Chettipalayam Road, Eachanari – 641021
                  <br /> Coimbatore, Tamil Nadu
                </p>
                <a
                  href={mapUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[13px] font-bold text-[#ffd600] hover:underline mt-2 inline-flex items-center gap-1.5"
                >
                  <FaDiamondTurnRight className="text-[#ff0336]" /> Get Directions
                </a>
              </div>

              {/* Working Hours */}
              <div className="flex flex-col relative">
                <h3 className="text-[18px] sm:text-[20px] font-bold mb-6 text-yellow-500">
                  Working Hours
                </h3>
                <span className="bg-brand-gradient w-[50px] h-[3px] absolute top-[28px]"></span>
                <div className="text-[14px] font-medium text-neutral-400 leading-relaxed">
                  <p className="font-bold mb-1 text-white">Monday – Saturday</p>
                  <p className="text-neutral-300">5:00 AM – 10:00 PM</p>
                  <p className="font-bold mt-2 text-[#ff007f]">Sunday – Holiday</p>
                </div>
              </div>

              {/* Contact Info */}
              <div className="flex flex-col relative">
                <h3 className="text-[18px] sm:text-[20px] font-bold mb-6 text-[#ff2a2a]">
                  Contact Info
                </h3>
                <span className="bg-brand-gradient w-[50px] h-[3px] absolute top-[28px]"></span>
                <div className="text-[14px] font-medium text-neutral-400 flex flex-col gap-2.5">
                  <a
                    href="tel:8637488702"
                    className="hover:text-[#ffd600] text-neutral-300 transition-colors duration-200 flex items-center gap-2"
                  >
                    <FaPhone className="text-[#ff2a2a] shrink-0" /> +91 86374 88702
                  </a>
                  <a
                    href="tel:9597557006"
                    className="hover:text-[#ffd600] text-neutral-300 transition-colors duration-200 flex items-center gap-2"
                  >
                    <FaPhone className="text-[#ff2a2a] shrink-0" /> +91 95975 57006
                  </a>
                  <a
                    href="mailto:nknandhu.fitness@gmail.com"
                    className="hover:text-[#ffd600] text-neutral-300 transition-colors duration-200 break-all flex items-center gap-2"
                  >
                    <FaEnvelope className="text-[#ff2a2a] shrink-0" />
                    nknandhu.fitness@gmail.com
                  </a>
                </div>
              </div>

              {/* Follow Us */}
              <div className="flex flex-col relative">
                <h3 className="text-[18px] sm:text-[20px] font-bold mb-6 text-yellow-500">
                  Follow Us On
                </h3>
                <span className="bg-brand-gradient w-[50px] h-[3px] absolute top-[28px]"></span>
                <div className="text-[18px] font-medium flex gap-4">
                  <a
                    href="https://www.instagram.com/nk_.nandhu"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Instagram"
                    className="px-3.5 py-3 bg-neutral-900 border border-neutral-800 text-white rounded-full cursor-pointer hover:bg-brand-gradient transition duration-200 flex items-center justify-center shadow"
                  >
                    <FaInstagram />
                  </a>
                  <a
                    href="https://wa.me/918637488702"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="WhatsApp"
                    className="p-3 bg-neutral-900 border border-neutral-800 text-white rounded-full cursor-pointer hover:bg-[#25D366] transition duration-200 flex items-center justify-center shadow"
                  >
                    <FaWhatsapp />
                  </a>
                </div>
              </div>
            </div>

            {/* Quick action buttons */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-10 sm:mt-14">
              <a
                href="https://wa.me/918637488702?text=Hi%2C%20I%20want%20to%20book%20a%20free%20trial%20at%20FAT2FIT%20Eachanari!"
                target="_blank"
                rel="noreferrer"
                className="bg-brand-gradient text-white font-bold uppercase text-[12px] sm:text-[13px] py-3.5 px-6 tracking-wider hover-brand-gradient transition-all duration-300 flex items-center justify-center gap-2 rounded-xl shadow-lg"
              >
                <FaWhatsapp className="text-[16px]" /> Book Free Trial on WhatsApp
              </a>
              <a
                href="tel:8637488702"
                className="bg-neutral-900 border border-neutral-700 text-white hover:border-[#ffd600] hover:text-[#ffd600] font-bold uppercase text-[12px] sm:text-[13px] py-3.5 px-6 tracking-wider transition-all duration-300 flex items-center justify-center gap-2 rounded-xl shadow"
              >
                <FaPhone className="text-[14px] text-[#ffd600]" /> Call Now
              </a>
            </div>
          </div>

          {/* Enquiry Form */}
          <form
            className="flex flex-col p-6 sm:p-8 md:p-10 bg-neutral-950 border border-neutral-900 rounded-2xl relative w-full shadow-2xl"
            onSubmit={(e) => {
              e.preventDefault();
              const name = e.target.name.value;
              const phone = e.target.phone.value;
              const service = e.target.service.value;
              const msg = e.target.message.value;
              const text = `Hi FAT2FIT! My name is ${name} (Phone: ${phone}). I am interested in ${service}. Message: ${msg}`;
              window.open(
                `https://wa.me/918637488702?text=${encodeURIComponent(text)}`,
                "_blank"
              );
            }}
          >
            <h3 className="text-[22px] sm:text-[26px] font-bold mb-8 text-white">
              Send Us an Enquiry
            </h3>
            <span className="bg-brand-gradient w-[50px] h-[3px] absolute top-[60px] sm:top-[68px]"></span>

            <input
              id="contact-name"
              name="name"
              required
              className="w-full bg-black text-white py-3 px-4 h-[48px] text-[14px] border border-neutral-800 outline-none mb-4 focus:border-[#ffd600] rounded-lg"
              placeholder="Full Name *"
              type="text"
            />
            <input
              id="contact-phone"
              name="phone"
              required
              className="w-full bg-black text-white py-3 px-4 h-[48px] text-[14px] border border-neutral-800 outline-none mb-4 focus:border-[#ffd600] rounded-lg"
              placeholder="Phone Number *"
              type="tel"
            />
            <select
              id="contact-service"
              name="service"
              className="w-full bg-black text-white py-3 px-4 h-[48px] text-[14px] border border-neutral-800 outline-none mb-4 focus:border-[#ffd600] rounded-lg"
            >
              <option value="General Gym Membership">General Gym Membership</option>
              <option value="Early Bird / Special Offer">Early Bird / Special Offer</option>
              <option value="Couple Package">Couple Package</option>
              <option value="Personal Training (PT)">Personal Training (PT)</option>
              <option value="Weight Training">Weight Training</option>
              <option value="Cardio Training">Cardio Training</option>
              <option value="Strength & Conditioning">Strength &amp; Conditioning</option>
              <option value="Body Transformation">Body Transformation</option>
              <option value="Book a Free Trial">Book a Free Trial</option>
            </select>
            <textarea
              id="contact-message"
              name="message"
              placeholder="Your Message (e.g. preferred workout timing, fitness goals)"
              className="w-full bg-black text-white py-3 px-4 h-[120px] text-[14px] border border-neutral-800 outline-none mb-6 focus:border-[#ffd600] rounded-lg"
            ></textarea>
            <button
              id="contact-submit"
              type="submit"
              className="text-black bg-gradient-to-r from-[#ffd600] via-yellow-400 to-amber-500 w-full py-3.5 px-8 font-black text-[13px] sm:text-[14px] uppercase hover:opacity-95 transition-all duration-300 rounded-xl shadow-lg flex items-center justify-center gap-2"
            >
              <FaWhatsapp className="text-[18px]" /> Submit via WhatsApp
            </button>
          </form>
        </div>

        {/* Embedded Interactive Google Maps */}
        <div className="w-full bg-neutral-950 border-t border-neutral-900">
          <div className="container page-padding py-10">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-6">
              <div>
                <h3 className="text-[20px] sm:text-[24px] font-bold text-white flex items-center gap-2.5">
                  <FaLocationDot className="text-[#ff0336]" />
                  FAT2FIT Unisex Fitness Centre Location
                </h3>
                <p className="text-neutral-400 text-[13.5px] sm:text-[14.5px] mt-1">
                  219 F 10/1, Ground Floor, Chettipalayam Road, Eachanari – 641021, Coimbatore
                </p>
              </div>
              <a
                href={mapUrl}
                target="_blank"
                rel="noreferrer"
                className="bg-brand-gradient text-white font-bold text-[12px] sm:text-[13px] py-3 px-6 uppercase tracking-wider hover-brand-gradient transition-all duration-300 rounded-xl shadow-md shrink-0 flex items-center gap-2"
              >
                <FaMapLocationDot /> Open in Google Maps
              </a>
            </div>

            {/* Responsive Map Container */}
            <div className="w-full h-[360px] sm:h-[450px] rounded-2xl overflow-hidden border border-neutral-800 shadow-2xl relative">
              <iframe
                title="FAT2FIT Gym Location Eachanari Coimbatore"
                src={mapEmbedUrl}
                width="100%"
                height="100%"
                style={{ border: 0, filter: "contrast(1.05)" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>

        <Footer />
      </section>
    </>
  );
}

export default Contact;
